import { keyMirror } from 'redfish-core/lib/utils/utils'
export const actionTypes = keyMirror([
    'UPDATE_ADMIN',
    'UPDATE_ADMIN_USERS',
    'UPDATE_ADMIN_ADMINS',
])
